import React, { useState, useEffect } from "react";
import ipvLogo from "../../IPV-PNG-logo-White-Cropped 1.png";
import ProgressBar from "./ProgressBar";
import bgimage from "../../Background GIF.gif";
import bgimage1 from "../../Background-image.jpg";
import info from "../../InfoSaved.png";

const AgreementsSection = ({
  formData,
  onPrevious,
  onSaveDraft,
  onSubmit,
  error,
}) => {
  const [sectionData, setSectionData] = useState({
    agreement1: false,
    agreement2: false,
    agreement3: false,
    agreement4: false,
    agreement5: false,
    agreement6: false,
    ...formData, // Load initial form data
  });

  const [showDraftImage, setShowDraftImage] = useState(false);

  // Load saved form data from localStorage
  useEffect(() => {
    const savedData = localStorage.getItem("agreementsData");
    if (savedData) {
      setSectionData(JSON.parse(savedData));
    }
  }, []);

  const handleChange = (e) => {
    const { name, checked } = e.target;

    let updatedData;

    if (name === "agreement5" || name === "agreement6") {
      // Optional agreements use "Yes"/"No"
      updatedData = {
        ...sectionData,
        [name]: checked ? "Yes" : "No",
      };
    } else {
      // Mandatory agreements use boolean
      updatedData = {
        ...sectionData,
        [name]: checked,
      };
    }

    setSectionData(updatedData);
    localStorage.setItem("agreementsData", JSON.stringify(updatedData));
  };

  const handleSaveDraft = () => {
    localStorage.setItem("professionalData", JSON.stringify(formData));
    setShowDraftImage(true);
    setTimeout(() => setShowDraftImage(false), 3000);
  };

  const handleSubmit = () => {
    // Check if all agreements are checked
    const allChecked =
      sectionData.agreement1 &&
      sectionData.agreement2 &&
      sectionData.agreement3 &&
      sectionData.agreement4;

    if (!allChecked) {
      alert("Please accept all terms to proceed.");
      return;
    }

    // If all agreements are checked, proceed with submission
    onSubmit(sectionData);
  };

  return (
    <div className="agreements-container">
      <div className="main-wrapper">
        <img
          loading="lazy"
          src={bgimage}
          className="background-image"
          alt="background"
        />
        <div className="header-content">
          <img
            loading="lazy"
            src={bgimage1}
            className="background-image"
            alt="background"
          />
          <img
            loading="lazy"
            src={ipvLogo}
            alt="IPV Logo"
            className="ipv-logo"
          />
        </div>
        <div className="form-section">
          <form className="form-layout">
            <ProgressBar currentStep={3} />{" "}
            {/* Current step for Personal Section */}
            <div className="form-container">
              <div className="form-title">Agreement and Terms</div>
              <div className="form-content">
                {/* Agreement Checkboxes */}
                <div className="term-item">
                  <div className="term-checkbox-wrapper">
                    <label className="term-text" htmlFor="agreement1">
                      I agree to pay the non-refundable annual membership fees{" "}
                      <span className="red-asterisk">*</span>
                    </label>
                    <input
                      type="checkbox"
                      id="agreement1"
                      name="agreement1"
                      className="checkbox-icon"
                      checked={sectionData.agreement1}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="term-item">
                  <div className="term-checkbox-wrapper">
                    <label className="term-text" htmlFor="agreement2">
                      I agree to pay 2% Investment facilitation fee on every
                      investment & exit made in startups via IPV. Please note
                      that for direct investments via the IPV platform there is
                      no carry fees on Exits. For investments under specified
                      class(es) via the AIF (FirstPort Capital), IPV
                      International(Gift City Fund) carry fees on Exits would be
                      applicable as per the relevant class(es).{" "}
                      <span className="red-asterisk">*</span>
                    </label>
                    <input
                      type="checkbox"
                      id="agreement2"
                      name="agreement2"
                      className="checkbox-icon"
                      checked={sectionData.agreement2}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="term-item">
                  <div className="term-checkbox-wrapper">
                    <label className="term-text" htmlFor="agreement3">
                      I agree that all investments made by me are my personal
                      decisions, based on my own discretion & judgement. I will
                      not hold IPV Advisors Pvt. Ltd. responsible for any
                      information/forecasts/opinions/statements provided by the
                      startups. <span className="red-asterisk">*</span>
                    </label>
                    <input
                      type="checkbox"
                      id="agreement3"
                      name="agreement3"
                      className="checkbox-icon"
                      checked={sectionData.agreement3}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="term-item">
                  <div className="term-checkbox-wrapper">
                    <label className="term-text" htmlFor="agreement4">
                      I, hereby, promise to uphold confidentiality with respect
                      to all material shared by IPV, pertaining to the startups.
                      At no point will I share this information, available to
                      me, with any one else, including but not limited to family
                      members, friends, competition or any third party, without
                      the prior written approval of IPV Advisors Pvt. Ltd. HQ
                      team. In addition I accept the terms & conditions of the
                      NDA of IPV. Material, includes but not limited to
                      documents, evaluation reports, scorecard, webinar/investor
                      call details etc. Click here to view Terms & Conditions:
                      https://bit.ly/2Yy4m7l.{" "}
                      <span className="red-asterisk">*</span>
                    </label>
                    <input
                      type="checkbox"
                      id="agreement4"
                      name="agreement4"
                      className="checkbox-icon"
                      checked={sectionData.agreement4}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                {/* Agreement 5 – Optional */}
                <div className="term-item">
                  <div className="term-checkbox-wrapper">
                    <label className="term-text" htmlFor="agreement5">
                      I’m comfortable sharing my Commitment/Investment details
                      with individuals I have referred to IPV.
                    </label>
                    <input
                      type="checkbox"
                      id="agreement5"
                      name="agreement5"
                      className="checkbox-icon"
                      checked={sectionData.agreement5 === "Yes"}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                {/* Agreement 6 – Optional + Note below */}
                <div className="term-item">
                  <div className="term-checkbox-wrapper">
                    <label className="term-text" htmlFor="agreement6">
                      I would like to connect with my Relationship Manager to
                      share my referrals.
                      <span className="term-note blinking-note">
                        Note: Upon successful referral, you will receive a
                        ₹3,000 Amazon voucher. Your referral will also get 20%
                        off on their membership fee.
                      </span>
                    </label>
                    <input
                      type="checkbox"
                      id="agreement6"
                      name="agreement6"
                      className="checkbox-icon"
                      checked={sectionData.agreement6 === "Yes"}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>
            </div>
            {/* Error message */}
            {error && <div className="error-message">{error}</div>}
            {/* Success message */}
            {showDraftImage && (
              <div className="draft-toast-fullscreen">
                <img
                  src={info}
                  alt="Draft saved"
                  className="draft-toast-image"
                />
              </div>
            )}
            <div className="button-wrapper">
              <button
                type="button"
                className="filled-button"
                onClick={onPrevious}
              >
                Previous
              </button>
              <button
                type="button"
                className="outlined-button"
                onClick={handleSaveDraft}
              >
                Save Draft
              </button>
              <button
                type="button"
                className="filled-button"
                onClick={handleSubmit}
              >
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AgreementsSection;
